import { z } from "zod";

export const SourceStatus = z.enum(["Active", "Expired", "Cancelled"]);

export type SourceStatusEnum = z.infer<typeof SourceStatus>;

export const SourceStatusDisplayName: Record<SourceStatusEnum, string> = {
  [SourceStatus.enum.Active]: "Active",
  [SourceStatus.enum.Expired]: "Expired",
  [SourceStatus.enum.Cancelled]: "Cancelled",
};
